import { GroupCategoryEnum } from "@/enums/groups/GroupCategoryEnum"
import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { Group } from "@/interfaces/Group"
import { AcceptableInputValue } from "radix-vue/dist/TagsInput/TagsInputRoot"
import { useBot } from "./useBot"

const axios = useAxios()

export interface CreateGroupDTO {
  name: string
  category: GroupCategoryEnum
  groupId: string
  newMembersAcceptanceDelay?: number
  welcomeMessage?: string
  accessUrl?: string
  paymentPlanIds?: AcceptableInputValue[]
  newMembersAutomaticApproval?: boolean
}

export interface UpdateGroupDTO {
  name: string
  category: GroupCategoryEnum
  groupId: string
  newMembersAcceptanceDelay?: number
  welcomeMessage?: string
  accessUrl?: string
  paymentPlanIds?: AcceptableInputValue[]
}

export interface GetAllGroupsParams {
  page?: string
  perPage?: string
}

export function useGroup() {
  const { selectedBot } = useBot()

  const create = async (payload: CreateGroupDTO): Promise<Group> => {
    if (payload.paymentPlanIds && !payload.paymentPlanIds.length || payload.paymentPlanIds && payload.category === GroupCategoryEnum.FREE) {
      delete payload.paymentPlanIds
    }

    payload.groupId = payload.groupId.trim()

    const response = await axios.post(`/bots/${selectedBot.value?.id}/groups`, payload)

    return response.data
  }

  const update = async (id: number, payload: UpdateGroupDTO): Promise<void> => {
    if (payload.paymentPlanIds && !payload.paymentPlanIds.length || payload.paymentPlanIds && payload.category === GroupCategoryEnum.FREE) {
      delete payload.paymentPlanIds
    }

    payload.groupId = payload.groupId.trim()

    await axios.patch(`/bots/${selectedBot.value?.id}/groups/${id}`, payload)
  }

  const getAll = async (params?: GetAllGroupsParams): Promise<Pagination<Group>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/bots/${selectedBot.value?.id}/groups`, { params })

    return response.data
  }

  const destroy = async (id: number): Promise<void> => {
    await axios.delete(`/bots/${selectedBot.value?.id}/groups/${id}`)
  }

  const migrateLeads = async (fromGroupId: number, toGroupId: number): Promise<void> => {
    await axios.post(`/bots/${selectedBot.value?.id}/groups/migrate-leads`, {
      fromGroupId,
      toGroupId
    })
  }

  return {
    create,
    getAll,
    update,
    destroy,
    migrateLeads
  }
}